'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InkTabBarNode = require('./InkTabBarNode');

var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);

var _TabBarTabsNode = require('./TabBarTabsNode');

var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);

var _TabBarRootNode = require('./TabBarRootNode');

var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);

var _ScrollableTabBarNode = require('./ScrollableTabBarNode');

var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);

var _SaveRef = require('./SaveRef');

var _SaveRef2 = _interopRequireDefault(_SaveRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * This source code is quoted from rc-tabs.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * homepage: https://github.com/react-component/tabs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var ScrollableInkTabBar = function (_React$Component) {
  _inherits(ScrollableInkTabBar, _React$Component);

  function ScrollableInkTabBar() {
    _classCallCheck(this, ScrollableInkTabBar);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ScrollableInkTabBar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    _reactDom2["default"].findDOMNode(this).addEventListener('DNDclick', function (e) {
      if (e && e.detail && e.detail.key) {
        _this2.props.onTabClick.call(_this2, e.detail.key);
      }
    });
  };

  ScrollableInkTabBar.prototype.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    _reactDom2["default"].findDOMNode(this).removeEventListener('DNDclick', function (e) {
      if (e && e.detail && e.detail.key) {
        _this3.props.onTabClick.call(_this3, e.detail.key);
      }
    });
  };

  ScrollableInkTabBar.prototype.render = function render() {
    var _props = this.props,
        renderTabBarNode = _props.children,
        restProps = _objectWithoutProperties(_props, ['children']);

    return _react2["default"].createElement(
      _SaveRef2["default"],
      null,
      function (saveRef, getRef) {
        return _react2["default"].createElement(
          _TabBarRootNode2["default"],
          _extends({ saveRef: saveRef }, restProps),
          _react2["default"].createElement(
            _ScrollableTabBarNode2["default"],
            _extends({ saveRef: saveRef, getRef: getRef }, restProps),
            _react2["default"].createElement(_TabBarTabsNode2["default"], _extends({ saveRef: saveRef, renderTabBarNode: renderTabBarNode }, restProps)),
            _react2["default"].createElement(_InkTabBarNode2["default"], _extends({ saveRef: saveRef, getRef: getRef }, restProps))
          )
        );
      }
    );
  };

  return ScrollableInkTabBar;
}(_react2["default"].Component);

exports["default"] = ScrollableInkTabBar;


ScrollableInkTabBar.propTypes = {
  children: _propTypes2["default"].func
};
module.exports = exports['default'];